(() => {
  const refreshTrust = () => {
    document.querySelectorAll('.kz-trust__item').forEach((item) => {
      const heading = item.querySelector('b');
      const note = item.querySelector('small');
      if (heading && heading.textContent.trim() === 'Dobre opinie klientów') {
        heading.textContent = 'Tysiące klientów KRUZER';
        if (note) note.textContent = 'Oceny sięgające 4,9/5';
      }
    });

    const panel = document.querySelector('.kz-store-reviews__google');
    if (panel && panel.dataset.kzTrustRefreshed !== 'true') {
      panel.dataset.kzTrustRefreshed = 'true';

      const label = panel.querySelector('.kz-store-reviews__brandline small');
      const title = panel.querySelector('.kz-store-reviews__brandline h3');
      const mark = panel.querySelector('.kz-store-reviews__googlemark');
      const intro = panel.querySelector(':scope > p');
      const list = panel.querySelector('dl');
      const note = panel.querySelector('.kz-store-reviews__disclaimer');

      if (label) label.textContent = 'NAJCZĘŚCIEJ DOCENIANE';
      if (title) title.textContent = 'Za co klienci polecają KRUZER';
      if (mark) {
        mark.textContent = '✓';
        mark.style.color = '#1e8a4a';
      }
      if (intro) intro.textContent = 'Najczęściej powtarzające się mocne strony w zweryfikowanych opiniach klientów.';
      if (list) {
        list.innerHTML = [
          ['Szybka i bezpieczna dostawa', 'doceniane'],
          ['Sprzęt zgodny z opisem', 'doceniane'],
          ['Pomoc w doborze właściwej mocy', 'doceniane'],
          ['Sprawny kontakt i obsługa po zakupie', 'doceniane']
        ].map(([name, value]) => `<div><dt>${name}</dt><dd><i></i>${value}</dd></div>`).join('');
      }
      if (note) note.textContent = 'Podsumowanie dotyczy obsługi sklepu i procesu zakupu, a nie parametrów technicznych konkretnego modelu.';
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshTrust, { once: true });
  } else {
    refreshTrust();
  }
  document.addEventListener('shopify:section:load', refreshTrust);
})();
